module.exports = "<h1>Welcome to this Place</h1>\n<p>Thank you for visiting this site.</p>"